import React, { useState, useEffect, Fragment } from "react";
import { MdRemoveCircle } from "react-icons/md";
import { FaWindowClose } from "react-icons/fa";
import DropDown from "../Ui/DropDown";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import {
    createJob,
    getAllMasterProcess,
    getQuotation,
    corporateCompanyJobSaveAsDraft,
    getAllBiometricCenters
} from "../../Redux/Actions/jobs";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getAllPaymentTypes } from "../../Redux/Actions/payment";
import LoadingButton from "../../utils/loadingButton";
import BasicTable from "../../utils/basicTable";
import { toastMessage } from "../../utils/toast";
import { Button, ButtonGroup, Card, Modal, ModalBody, ModalFooter, ModalHeader, OverlayTrigger, Tooltip } from "react-bootstrap";
import './file.css'
import { getCorporateJobById, getMetadata } from "../../Redux/Actions/jobs";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";

let ID = 1;
const initialRequestJob = {
    id: ID,
    documentName: "",
    passportNo: "",
    document: [],
    isApplicationRow: false,
    documentNameIsFilled: false,
    documentIsFilled: false,
    isOldDocument: false,
    oldDocument: [],
    documentIds: [],
    applicationNo: [],
    applicationName: [],
    applicationEmail: [],
    applicationMobile: [],
    centerId: '',
    gender: 0,
    applicationEmailIsFilled: false,
    applicationEmailFormatInvalid: false,
    applicationNoIsFilled: false,
    applicationNoInvalid: false,
    applicationNoMinLength: false,
    applicationNoStartWith01: false,
    applicationNameIsFilled: false,
    applicationMobileIsFilled: false,
    applicationMobileInvalid: false,
    genderIsFilled: false,
};

// Validation helpers
const validateEmail = (email) => /^\S+@\S+\.\S+$/.test(email);
const validateApplicationNo = (no) => /^\d{1,25}$/.test(no);
const validateName = (name) => typeof name === 'string' && name.length > 0 && name.length <= 100;
const hasApplicationValues = (job) => {
    const hasValue = (value) => Array.isArray(value)
        ? value.some((item) => item !== null && item !== undefined && String(item).trim() !== '')
        : value !== null && value !== undefined && String(value).trim() !== '';

    return hasValue(job?.applicationNo)
        || hasValue(job?.applicationName)
        || hasValue(job?.applicationEmail)
        || hasValue(job?.applicationMobile)
        || hasValue(job?.centerId)
        || job?.gender === 0
        || job?.gender === 1;
};
const isApplicationOnlyRow = (job) => job?.isApplicationRow === true;
const hasAnyDocument = (job) => (job?.document?.length || 0) > 0 || (job?.oldDocument?.length || 0) > 0;

function Edit({ history }) {
    const { id } = useParams();
    const [departmentId, setDepartmentID] = useState("");
    const [masterProcessId, setMasterProcessID] = useState("");
    const [processId, setProcessID] = useState("");
    const [departmentList, setDepartmentList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [poNumber, setPoNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [requestJobLoading, setRequestJobLoading] = useState(false);
    const [quotation, setQuotation] = useState({
        data: null,
        headers: [],
        rows: [],
    });
    const [requestJob, setRequestJob] = useState({
        isRequestJob: false,
        data: [initialRequestJob],
        id: 1,
    });
    const { t } = useTranslation();
    const [departmentIdFlag, setDepartmentIdFlag] = useState(false);
    const [masterProcessIdFlag, setMasterProcessIdFlag] = useState(false);
    const [processIdFlag, setProcessIdFlag] = useState(false);
    const [poNumberFlag, setPoNumberFlag] = useState(false);
    const [paymentType, setPaymentType] = useState({ label: 'Online', value: 1 });
    const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);
    const [jobDetail, setJobDetail] = useState({});
    const [oldDocuments, setOldDocuments] = useState([]);
    const [saveAsDraftLoading, setSaveAsDraftLoading] = useState(false);
    const [deleteDocumentIds, setDeleteDocumentIds] = useState([]);
    const [validationError, setValidationError] = useState('');
    const [biometricCenters, setBiometricCenters] = useState([]);

    useEffect(() => {
        if (id) {
            getCorporateJobByIdApi(id);
        }
    }, [id]);

    const getCorporateJobByIdApi = async (id) => {
        setPageLoading(true);
        try {
            const res = await apiWrapWithErrorWithData(getCorporateJobById(id));
            const response = res.data;
            setPoNumber(response?.data.poNumber)
            setJobDetail(response?.data);
        } catch (error) {
            console.log("getCorporateJobByIdApi:", error);
        }
        setPageLoading(false);
    };

    useEffect(() => {
        if (jobDetail) {
            let documentIds = "";
            jobDetail?.corporateCompanyJobDocuments?.forEach((list) => {
                if (documentIds)
                    documentIds += ','
                documentIds += list.documentIds.toString()
            })
            if (documentIds)
                getMetadataApi(documentIds)
        }
    }, [jobDetail])

    useEffect(() => {
        if (jobDetail && paymentTypeOptions) {
            const paymentType = paymentTypeOptions?.filter((list) => list.label === jobDetail.paymentType).map((list) => list)
            setPaymentType(paymentType[0])
        }
    }, [jobDetail, paymentTypeOptions])

    const getMetadataApi = async (ids) => {
        const res = await apiWrapWithErrorWithData(getMetadata(ids));
        if (res && res.data) {
            setOldDocuments(res.data);
        } else {
            setOldDocuments([]);
        }
    }

    useEffect(() => {
        if (oldDocuments) {
            const documentData = jobDetail.corporateCompanyJobDocuments?.map((list) => {
                const hasStoredDocumentIds = Array.isArray(list.documentIds)
                    && list.documentIds.some((documentId) => documentId !== null && documentId !== undefined);
                const isApplicationRow = !hasStoredDocumentIds && hasApplicationValues(list);

                return {
                    id: list.id,
                    documentName: list.documentName,
                    passportNo: list.passportNo || '',
                    document: [],
                    isApplicationRow,
                    oldDocument: getDocumentDetail(list.documentIds),
                    isOldDocument: list.documentIds ? true : false,
                    documentNameIsFilled: false,
                    documentIsFilled: false,
                    documentIds: list.documentIds || [],
                    applicationNo: list.applicationNo || [],
                    applicationName: list.applicationName || [],
                    applicationEmail: list.applicationEmail || [],
                    centerId: list.centerId || '',
                    applicationMobile: list.applicationMobile || [],
                    gender: list.applicantGender === "Male" ? 0 : 1,
                }
            })
            if (documentData)
                setRequestJob((preState) => ({
                    ...preState,
                    data: [...documentData]
                }));
        }
    }, [oldDocuments, jobDetail])

    const getDocumentDetail = (ids) => {
        return ids.map((id) => {
            return getdocumentsByIds(id)[0];
        })
    }

    const getdocumentsByIds = (id) => {
        return oldDocuments.filter(doc => doc.documentId === id).map(({ documentId, fileName }) => {
            return {
                name: fileName,
                id: documentId
            }
        });;
    }

    useEffect(() => {
        if (jobDetail && departmentList) {
            const localDepartmentList = departmentList.filter((departmentData) => departmentData.value == jobDetail.departmentId);
            setDepartmentID(localDepartmentList[0])
            if (localDepartmentList[0]?.masterProcess) {
                let localMasterProcessList = localDepartmentList[0]?.masterProcess.map(({ name, id, process }) => ({
                    label: name,
                    value: id,
                    process: process,
                }));
                if (localMasterProcessList)
                    localMasterProcessList.unshift({ label: "Select Department", value: 0, process: [] });
                setMasterProcessList(localMasterProcessList);
                const localMasterProcessListMap = localMasterProcessList?.filter((list) => list.value == jobDetail.masterProcessId).map((list) => list)
                setMasterProcessID(localMasterProcessListMap[0])
                let processList = localMasterProcessListMap[0]?.process.map(({ name, id }) => ({ label: name, value: id }));
                processList.unshift({ label: "Select Master process", value: 0 });
                setProcessList(processList);
                const localProcessList = processList.filter((list) => list.value == jobDetail.processId).map((list) => list)
                setProcessID(localProcessList[0]);
            }
        }
    }, [jobDetail, departmentList])

    useEffect(() => {
        getMasterProcessApi();
        getAllPaymentTypesApi();
        fetchBiometricCenters();
    }, []);

    const fetchBiometricCenters = async () => {
        try {
            const res = await apiWrapWithErrorWithData(getAllBiometricCenters());
            if (res && res.data && Array.isArray(res.data)) {
                setBiometricCenters(res.data.filter(center => center.isActive === true).map(center => ({ label: center.name, value: center.id })));
            } else {
                setBiometricCenters([]);
            }
        } catch (error) {
            setBiometricCenters([]);
        }
    };

    useEffect(() => {
        if (quotation.data != null) {
            setQuotation((preState) => ({
                ...preState,
                headers: Object.keys(quotation.data),
                rows: [quotation.data],
            }));
        }
    }, [quotation.data]);

    const handleList = (key, ID) => {
        let list = [];
        if (key === "department") {
            list = departmentList.filter(({ value }) => value === ID)[0]
                .masterProcess;
            list = list.map(({ name, id, process }) => ({
                label: name,
                value: id,
                process: process,
            }));
            list.unshift({ label: "Select Department", value: 0, process: [] });
            setMasterProcessList(list);
            setProcessList([]);
            setMasterProcessID("");
            setProcessID("");
        } else {
            list = masterProcessList.filter(({ value }) => value === ID)[0].process;
            list = list.map(({ name, id }) => ({ label: name, value: id }));
            list.unshift({ label: "Select Master process", value: 0 });
            setProcessList(list);
        }
    };

    const getMasterProcessApi = async () => {
        try {
            const res = await apiWrapWithErrorWithData(getAllMasterProcess());
            const { data } = res.data;
            let departmentsList = data?.department;
            departmentsList = departmentsList.map(({ name, id, masterProcess }) => ({
                label: name,
                value: id,
                masterProcess: masterProcess,
            }));
            departmentsList.unshift({
                label: "Select Department",
                value: 0,
                masterProcess: [],
            });
            setDepartmentList(departmentsList || []);
        } catch (error) {
            console.log("getMasterProcessApi", error)
        }
    };

    //Get payment types
    const getAllPaymentTypesApi = async () => {
        try {
            const res = await apiWrapWithErrorWithData(getAllPaymentTypes());
            const { data } = res.data;
            // setPaymentTypeOptions(data || []);
            setPaymentTypeOptions((data || []).filter(option => option.value === 1 || option.value === 3));


        } catch (error) {
            console.log("getMasterProcessApi", error)
        }
    };

    const setFlag = () => {
        setDepartmentIdFlag(false)
        setMasterProcessIdFlag(false)
        setProcessIdFlag(false)
        setPoNumberFlag(false)
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        let flag = false;
        setFlag();
        if (departmentId.label === undefined) {
            setDepartmentIdFlag(true);
            flag = true;
        }
        if (masterProcessId.label === undefined) {
            setMasterProcessIdFlag(true);
            flag = true;
        }
        if (processId.label === undefined) {
            setProcessIdFlag(true);
            flag = true;
        }
        if (poNumber === '') {
            setPoNumberFlag(true);
            flag = true;
        }
        let appFieldError = false;
        const numberRegex = /^\d+$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        requestJob.data.forEach((job, idx) => {
            // Reset flags
            const resetFlags = {
                applicationEmailIsFilled: false,
                applicationEmailFormatInvalid: false,
                applicationNoIsFilled: false,
                applicationNoInvalid: false,
                applicationNoMinLength: false,
                applicationNoStartWith01: false,
                applicationNameIsFilled: false,
                applicationMobileIsFilled: false,
                applicationMobileInvalid: false,
                genderIsFilled: false,
            };

            setRequestJob(prevState => {
                const newData = [...prevState.data];
                newData[idx] = { ...newData[idx], ...resetFlags };
                return { ...prevState, data: newData };
            });

            if (isApplicationOnlyRow(job)) {
                const appNo = Array.isArray(job.applicationNo) ? job.applicationNo[0] : job.applicationNo;
                const appName = Array.isArray(job.applicationName) ? job.applicationName[0] : job.applicationName;
                const appEmail = Array.isArray(job.applicationEmail) ? job.applicationEmail[0] : job.applicationEmail;
                const appMobile = Array.isArray(job.applicationMobile) ? job.applicationMobile[0] : job.applicationMobile;
                const gender = job.gender;

                // Sequential Validation for Email
                if (!appEmail) {
                    setRequestJob(ps => { ps.data[idx].applicationEmailIsFilled = true; return { ...ps }; });
                    appFieldError = true;
                } else if (!emailRegex.test(appEmail)) {
                    setRequestJob(ps => { ps.data[idx].applicationEmailFormatInvalid = true; return { ...ps }; });
                    appFieldError = true;
                }

                // Sequential Validation for Application No
                if (!appNo) {
                    setRequestJob(ps => { ps.data[idx].applicationNoIsFilled = true; return { ...ps }; });
                    appFieldError = true;
                } else if (!numberRegex.test(appNo)) {
                    setRequestJob(ps => { ps.data[idx].applicationNoInvalid = true; return { ...ps }; });
                    appFieldError = true;
                } else if (!appNo.startsWith('01')) {
                    setRequestJob(ps => { ps.data[idx].applicationNoStartWith01 = true; return { ...ps }; });
                    appFieldError = true;
                } else if (appNo.length < 20) {
                    setRequestJob(ps => { ps.data[idx].applicationNoMinLength = true; return { ...ps }; });
                    appFieldError = true;
                } else if (appNo.length > 25) {
                    setRequestJob(ps => { ps.data[idx].applicationNoInvalid = true; return { ...ps }; });
                    appFieldError = true;
                }

                // Validation for Name
                if (!appName) {
                    setRequestJob(ps => { ps.data[idx].applicationNameIsFilled = true; return { ...ps }; });
                    appFieldError = true;
                }

                // Sequential Validation for Mobile
                if (!appMobile) {
                    setRequestJob(ps => { ps.data[idx].applicationMobileIsFilled = true; return { ...ps }; });
                    appFieldError = true;
                } else if (!numberRegex.test(appMobile) || appMobile.length < 7 || appMobile.length > 15) {
                    setRequestJob(ps => { ps.data[idx].applicationMobileInvalid = true; return { ...ps }; });
                    appFieldError = true;
                }

                // Validation for Gender
                if (gender !== 0 && gender !== 1) {
                    setRequestJob(ps => { ps.data[idx].genderIsFilled = true; return { ...ps }; });
                    appFieldError = true;
                }
            }
        });
        if (flag || appFieldError) {
            setIsLoading(false);
            return;
        }
        setFlag();
        let isFilled = false;
        requestJob.data.forEach((job, index) => {
            if (isApplicationOnlyRow(job)) {
                return;
            }

            if (job.documentName.trim() === '') {
                isFilled = true;
                changeRequestJobDocumentNameIsFilled(index, true);
            }
            if (!hasAnyDocument(job)) {
                isFilled = true;
                changeRequestJobDocumentIsFilled(index, true);
            }
        });
        if (isFilled) {
            console.log("handleSubmit -> isFilled", isFilled, departmentId, masterProcessId, processId, poNumber, requestJob);
            toastMessage("error", "Fill the Fields");
            setIsLoading(false);
            return;
        }
        const payload = {
            departmentId: departmentId?.value,
            masterProcessId: masterProcessId?.value,
            processId: processId?.value,
            jobCount: requestJob.data.length,
            poNumber: poNumber
        };
        try {
            const res = await apiWrapWithErrorWithData(getQuotation(payload));
            const response = res.data;
            if (response.data) {
                setQuotation((preState) => ({ ...preState, data: response?.data }));
                setRequestJob((preState) => ({ ...preState, isRequestJob: true }))
            }
        } catch (error) {
            console.log("handleSubmitCreateQuotation", error);
        }
        setIsLoading(false);
        setShowModal(true);
    };

    const onChange = (index) => (event) => {
        setRequestJob((preState) => ({
            ...preState,
            data: [
                ...preState.data.slice(0, index),
                {
                    ...preState.data[index],
                    documentNameIsFilled: event.target.name === "documentName" ? false : preState.data[index].documentNameIsFilled,
                    [event.target.name]:
                        event.target.name === "document"
                            ? event.target.files[0]
                            : event.target.value,
                },
                ...preState.data.slice(index + 1),
            ],
        }));
    };

    const changeRequestJobDocumentNameIsFilled = (index, flag) => {
        if (!isNaN(index) && flag !== undefined) {
            setRequestJob((prevState) => {
                const newData = [...prevState.data];
                newData[index].documentNameIsFilled = flag;
                return { ...prevState, data: newData };
            });
        }
    };

    const changeRequestJobDocumentIsFilled = (index, flag) => {
        if (!isNaN(index) && flag !== undefined) {
            setRequestJob((prevState) => {
                const newData = [...prevState.data];
                newData[index].documentIsFilled = flag;
                return { ...prevState, data: newData };
            });
        }
    };

    const handleFileChange = (index, event) => {
        const files = event.target.files;
        const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'application/x-zip-compressed', 'application/x-compressed'];
        const filteredFiles = Array.from(files).filter(file => allowedFormats.includes(file.type));

        if (filteredFiles.length !== files.length) {
            toastMessage("error", 'Invalid file format. Please select only jpg, jpeg, png, pdf, or zip files.');
            event.target.value = '';
            return;
        }

        if (filteredFiles.length > 15) {
            toastMessage("error", 'Please select less than 15 files.');
            event.target.value = '';
            return;
        }

        setRequestJob((prevState) => {
            const newData = [...prevState.data];
            const existingFiles = newData[index].document || [];

            if (existingFiles.length + filteredFiles.length > 15) {
                toastMessage("error", 'Total number of files should be less than 15.');
                event.target.value = '';
                return prevState;
            }

            newData[index].document = existingFiles.concat(filteredFiles);
            newData[index].documentIsFilled = false;
            return { ...prevState, data: newData };
        });
    };

    const handleFileDelete = (fileIndex, documentIndex) => {
        setRequestJob((prevState) => {
            const newData = [...prevState.data];
            newData[documentIndex].document = newData[documentIndex].document.filter((_, index) => index !== fileIndex) || [];
            return { ...prevState, data: newData };
        });
    };

    const handleExistingFileDelete = (fileIndex, documentIndex) => {
        setDeleteDocumentIds([...deleteDocumentIds, ...[fileIndex]])
        setRequestJob((prevState) => {
            const newData = [...prevState.data];
            newData[documentIndex].oldDocument = newData[documentIndex].oldDocument.filter((list) => list.id !== fileIndex) || [];
            return { ...prevState, data: newData };
        });
    };

    const onAddHandler = () => {
        if (requestJob.data.length >= 30) {
            toastMessage("error","Cannot add more than 30 rows");
            return;
        }
        setRequestJob((preState) => {
            const shouldAddApplicationRow = preState.data.length > 0
                && preState.data.every((row) => isApplicationOnlyRow(row));
            const firstRow = preState.data[0] || {};
            const newRow = shouldAddApplicationRow
                ? {
                    ...initialRequestJob,
                    id: preState.data.length + 1,
                    isApplicationRow: true,
                    documentIds: [null],
                    applicationNo: [''],
                    applicationName: [''],
                    applicationEmail: [''],
                    applicationMobile: [''],
                    centerId: firstRow.centerId || jobDetail?.corporateCompanyJobDocuments?.[0]?.centerId || '',
                    gender: 0,
                }
                : { ...initialRequestJob, id: preState.data.length + 1, documentName: '', document: [] };

            return {
                ...preState,
                data: [...preState.data, newRow],
            };
        });
    };

    const onRemoveHandler = (index) => {
        setRequestJob((preState) => ({
            ...preState,
            data: preState.data.filter((_, i) => i !== index),
        }));
    };

    const handleApplicationFieldChange = (rowIdx, field, arrIdx, value) => {
        setRequestJob(prevState => {
            const newData = [...prevState.data];
            if (!Array.isArray(newData[rowIdx][field])) {
                newData[rowIdx][field] = [newData[rowIdx][field] || ''];
            }
            newData[rowIdx][field][arrIdx] = value;
            // Clear validation flags
            newData[rowIdx][`${field}IsFilled`] = false;
            newData[rowIdx][`${field}Invalid`] = false;
            if (field === 'applicationNo') {
                newData[rowIdx].applicationNoMinLength = false;
                newData[rowIdx].applicationNoStartWith01 = false;
            } else if (field === 'applicationEmail') {
                newData[rowIdx].applicationEmailFormatInvalid = false;
            }
            return { ...prevState, data: newData };
        });
    };

    const handleCenterChange = (rowIdx, value) => {
        setRequestJob(prevState => {
            const newData = [...prevState.data];
            newData[rowIdx].centerId = value;
            return { ...prevState, data: newData };
        });
    };

    const handleGenderChange = (rowIdx, value) => {
        setRequestJob(prevState => {
            const newData = [...prevState.data];
            newData[rowIdx].gender = value;
            newData[rowIdx].genderIsFilled = false;
            return { ...prevState, data: newData };
        });
    };

    const handleSaveAsDraft = async () => {
        setSaveAsDraftLoading(true);
        try {
            const [processes] = masterProcessList.filter(masPro => (masPro.value === parseInt(masterProcessId.value, 10)));
            const [formId] = processes?.process.filter(pro => pro.id === parseInt(processId?.value, 10));
            const formData = new FormData();
            formData.append("Id", jobDetail.id);
            formData.append("DepartmentId", departmentId?.value);
            formData.append("MasterProcessId", masterProcessId?.value);
            formData.append("ProcessId", processId?.value);
            formData.append("FormId", formId?.formId);
            formData.append("JobCount", requestJob.data.length);
            formData.append("poNumber", poNumber);
            formData.append("PaymentType", paymentType.value);
            deleteDocumentIds.forEach((value, index) => {
                formData.append(`DeletedDocumentIds[${index}]`, value);
            });
            var i = 0;
            requestJob.data.forEach((index) => {
                changeRequestJobDocumentNameIsFilled(index, false)
                changeRequestJobDocumentIsFilled(index, false)
            });
            let isFilled = false
            requestJob.data.forEach(({ document, documentName, passportNo, oldDocument, isApplicationRow, applicationNo, applicationName, applicationEmail, applicationMobile, centerId, gender }, index) => {
                if (!isApplicationRow && documentName.trim() === '') {
                    isFilled = true;
                    changeRequestJobDocumentNameIsFilled(index, true)
                }
                let isFileFilled = true
                document.forEach((file) => {
                    formData.append(`DocumentName[${i}]`, documentName);
                    formData.append(`PassportNo[${i}]`, passportNo || "");
                    formData.append(`Documents`, file);
                    isFileFilled = false;
                    i++;
                });
                if (!isApplicationRow && isFileFilled && oldDocument.length === 0) {
                    isFilled = true;
                    changeRequestJobDocumentIsFilled(index, true)
                }
                if (isApplicationRow) {
                    formData.append(`CenterId[${index}]`, centerId || jobDetail.corporateCompanyJobDocuments?.[0]?.centerId || '');
                    (Array.isArray(applicationNo) ? applicationNo : [applicationNo]).forEach((val) => {
                        formData.append(`ApplicationNo[${index}]`, val);
                    });
                    (Array.isArray(applicationName) ? applicationName : [applicationName]).forEach((val) => {
                        formData.append(`Name[${index}]`, val);
                    });
                    (Array.isArray(applicationEmail) ? applicationEmail : [applicationEmail]).forEach((val) => {
                        formData.append(`Email[${index}]`, val);
                    });
                    (Array.isArray(applicationMobile) ? applicationMobile : [applicationMobile]).forEach((val) => {
                        formData.append(`Mobile[${index}]`, val);
                    });
                    (Array.isArray(gender) ? gender : [gender]).forEach((val) => {
                        formData.append(`Gender[${index}]`, val);
                    }); 
                }
            });

            if (isFilled) {
                toastMessage("error", "Fill the Fields");
                setSaveAsDraftLoading(false);
                return
            }
            const res = await apiWrapWithErrorWithData(corporateCompanyJobSaveAsDraft(formData));
            if (res.status === 400) {
                toastMessage("error", res.data.message);
            } else if (res.status == 200) {
                toastMessage("success", res.data.message);
                history.push(`/jobs`)
            } else if (res.data.message === 'Job saved successfully.' || res.data.message === 'Job saved successfully') {
                toastMessage("success", res.data.message);
                history.push(`/jobs`)
            } else {
                const errorMsg = res.data && res.data.message ? res.data.message : (res.message ? "File too large. Please upload smaller files." : "An error occurred");
                if (res.data.validations) {
                    const validationErrors = res.data.validations;
                    console.log("Validation Errors:", validationErrors);
                    toastMessage('error', validationErrors.map((err, idx) => `${err}${idx !== validationErrors.length - 1 ? '\n\n' : ''}`).join(''));
                } else {
                    toastMessage("error", errorMsg);
                }
                setShowModal(false);
                //history.push(`/jobs`)
            }
        } catch (error) {
            console.log("handleRequestJob:", error);
        }
        setSaveAsDraftLoading(false);
    };

    const handleRequestJob = async () => {
        setRequestJobLoading(true);
        try {
            const [processes] = masterProcessList.filter(masPro => (masPro.value === parseInt(masterProcessId.value, 10)));
            const [formId] = processes?.process.filter(pro => pro.id === parseInt(processId?.value, 10));
            const formData = new FormData();
            formData.append("Id", jobDetail.id);
            formData.append("DepartmentId", departmentId?.value);
            formData.append("MasterProcessId", masterProcessId?.value);
            formData.append("ProcessId", processId?.value);
            formData.append("FormId", formId?.formId);
            formData.append("JobCount", requestJob.data.length);
            formData.append("poNumber", poNumber);
            formData.append("PaymentType", paymentType.value);
            deleteDocumentIds.forEach((value, index) => {
                formData.append(`DeletedDocumentIds[${index}]`, value);
            });
            var i = 0;
            let isFilled = false
            requestJob.data.forEach((index) => {
                changeRequestJobDocumentNameIsFilled(index, false)
                changeRequestJobDocumentIsFilled(index, false)
            });
            requestJob.data.forEach(({ document, documentName, passportNo, oldDocument, isApplicationRow, applicationNo, applicationName, applicationEmail, applicationMobile, centerId, gender }, index) => {
                if (!isApplicationRow && documentName.trim() === '') {
                    isFilled = true;
                    changeRequestJobDocumentNameIsFilled(index, true)
                }
                let isFileFilled = true
                document.forEach((file) => {
                    formData.append(`DocumentName[${i}]`, documentName);
                    formData.append(`PassportNo[${i}]`, passportNo || "");
                    formData.append(`Documents`, file);
                    isFileFilled = false;
                    i++;
                });
                if (!isApplicationRow && isFileFilled && oldDocument.length === 0) {
                    isFilled = true;
                    changeRequestJobDocumentIsFilled(index, true)
                }
                if (isApplicationRow) {
                    formData.append(`CenterId[${index}]`, centerId || jobDetail.corporateCompanyJobDocuments?.[0]?.centerId || '');
                    (Array.isArray(applicationNo) ? applicationNo : [applicationNo]).forEach((val) => {
                        formData.append(`ApplicationNo[${index}]`, val);
                    });
                    (Array.isArray(applicationName) ? applicationName : [applicationName]).forEach((val) => {
                        formData.append(`Name[${index}]`, val);
                    });
                    (Array.isArray(applicationEmail) ? applicationEmail : [applicationEmail]).forEach((val) => {
                        formData.append(`Email[${index}]`, val);
                    });
                    (Array.isArray(applicationMobile) ? applicationMobile : [applicationMobile]).forEach((val) => {
                        formData.append(`Mobile[${index}]`, val);
                    });
                    (Array.isArray(gender) ? gender : [gender]).forEach((val) => {
                        formData.append(`Gender[${index}]`, val);
                    });
                }
            });
            if (isFilled) {
                toastMessage("error", "Fill the Fields");
                setRequestJobLoading(false);
                return
            }
            const res = await apiWrapWithErrorWithData(createJob(formData));
            if (res.status === 400) {
                toastMessage("error", res.data.message);
            } else if (res?.Message != '' && res?.StackTraceString != null) {
                let errorMsg = res?.data?.message ? res.data.message : res.Message;
                setValidationError(errorMsg);
                toastMessage("error", errorMsg);
            } else if (res.status == 200 && res.data.data.isOnlinePayment && paymentType.value === 1) {
                toastMessage("success", res.data.message);
                history.push(`/checkout/${res.data.data.id}`)
            } else {
                const errorMsg = res.data && res.data.message ? res.data.message : (res.message ? "File too large. Please upload smaller files." : "An error occurred");
                if (res.data.validations) {
                    const validationErrors = res.data.validations;
                    console.log("Validation Errors:", validationErrors);
                    toastMessage('error', validationErrors.map((err, idx) => `${err}${idx !== validationErrors.length - 1 ? '\n\n' : ''}`).join(''));
                } else if(res.status == 200) {
                    toastMessage("success", errorMsg);
                    history.push(`/jobs`)
                }else {                    
                    toastMessage("error", errorMsg);
                }
                setShowModal(false);
                //history.push(`/jobs`)
            }
        } catch (error) {
            console.log("handleRequestJob:", error);
        }
        setRequestJobLoading(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    }
    const [expandedRows, setExpandedRows] = useState({});
    const [docsLimit] = useState(1);

    // Toggle expanded/collapsed state for a row
    const toggleExpand = (rowIndex, type) => {
        setExpandedRows((prevState) => ({
            ...prevState,
            [`${rowIndex}-${type}`]: !prevState[`${rowIndex}-${type}`],
        }));
    };
    return (
        <Fragment>
            {pageLoading ? (
                <div className="d-flex align-items-center justify-content-center h-75vh">
                    <Loader
                        type="ThreeDots"
                        color="#2d207d"
                        height={40}
                        width={40}
                        style={{ textAlign: "center" }}
                    />
                </div>
            ) : (
                <div>
                    <div className="d-flex">
                        <div className="me-3" style={{ width: "100%" }}>
                            <DropDown
                                isSearchable={true}
                                label={t("eidBasmati.department")}
                                placeholder={t("eidBasmati.selectDepartment")}
                                options={departmentList}
                                value={departmentId}
                                onChange={(value) => {
                                    setProcessList([]);
                                    handleList("department", value.value);
                                    setDepartmentID(value);
                                }}
                            />
                            {departmentIdFlag ? <span style={{ color: 'red' }}>Department is requied</span> : null}
                        </div>
                        <div className="me-3" style={{ width: "100%" }}>
                            <DropDown
                                isSearchable={true}
                                label={t("eidBasmati.masterProcess")}
                                placeholder={t("eidBasmati.selectMasterProcess")}
                                options={masterProcessList}
                                value={masterProcessId}
                                onChange={(value) => {
                                    handleList("masterProcess", value.value);
                                    setMasterProcessID(value);
                                }}
                            />
                            {masterProcessIdFlag ? <span style={{ color: 'red' }}>Master process is requied</span> : null}
                        </div>
                        <div className="me-3" style={{ width: "100%" }}>
                            <DropDown
                                isSearchable={true}
                                label={t("eidBasmati.process")}
                                placeholder={t("eidBasmati.selectProcess")}
                                options={processList}
                                value={processId}
                                onChange={(value) => {
                                    setProcessID(value);
                                }}
                            />
                            {processIdFlag ? <span style={{ color: 'red' }}>Process is requied</span> : null}
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="me-3" style={{ width: "32%" }}>
                            <label
                                className="form-label col-md-4 col-sm-2"
                                style={{ marginTop: "5px" }}
                            >
                                {t("eidBasmati.poNumber")}
                            </label>
                            <input
                                className="p-1 form-control col-md-4 col-sm-2"
                                type="text"
                                onChange={(e) => {
                                    setPoNumber(e.target.value);
                                }}
                                value={poNumber}
                                placeholder={t("eidBasmati.pleaseEnterPoNumber")}
                            />
                            {poNumberFlag ? <span style={{ color: 'red' }}>{t('eidBasmati.poNumberRequired')}</span> : null}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="d-flex gap-3 col-md-12">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={onAddHandler}
                            >
                                {t("eidBasmati.addRow")}
                            </button>
                            <div className="d-flex gap-3">
                                <h5>{t("eidBasmati.dataCount")} : </h5>
                                <h5>{requestJob.data.length}</h5>
                            </div>
                        </div>
                        <Card border="light" className="w-95 scrollable-card">
                            {requestJob.data.map((job, index) => (
                                <div key={job.id} className="d-flex row mt-4">
                                    <div className="col-md-1 text-center mt-3">
                                        <h6>{index + 1}</h6>
                                    </div>

                                    {isApplicationOnlyRow(job) ? (
                                        <>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>{t("eidBasmati.gender")}</label>
                                                    <div className="d-flex">
                                                        <ButtonGroup className="w-100 p-1">
                                                            <Button
                                                                variant={job.gender === 0 ? "primary" : "outline-primary"}
                                                                onClick={() => handleGenderChange(index, 0)}
                                                                size="sm"
                                                            >
                                                                M
                                                            </Button>
                                                            <Button
                                                                variant={job.gender === 1 ? "primary" : "outline-primary"}
                                                                onClick={() => handleGenderChange(index, 1)}
                                                                size="sm"
                                                            >
                                                                F
                                                            </Button>
                                                        </ButtonGroup>
                                                    </div>
                                                    {job.genderIsFilled && (
                                                        <small className="text-danger">Gender is required</small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>{t("eidBasmati.applicantEmail")}</label>
                                                    <input
                                                        name="applicationEmail"
                                                        type="email"
                                                        className="form-control mb-2"
                                                        placeholder="e.g.test@gmail.com"
                                                        value={Array.isArray(job.applicationEmail) ? job.applicationEmail[0] || '' : job.applicationEmail || ''}
                                                        onChange={e => handleApplicationFieldChange(index, 'applicationEmail', 0, e.target.value)}
                                                    />
                                                    {job.applicationEmailIsFilled ? (
                                                        <small className="text-danger">Applicant Email is required</small>
                                                    ) : job.applicationEmailFormatInvalid ? (
                                                        <small className="text-danger">Invalid email format</small>
                                                    ) : null}
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>{t("eidBasmati.applicationNo")}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control mb-2"
                                                        value={Array.isArray(job.applicationNo) ? job.applicationNo[0] || '' : job.applicationNo || ''}
                                                        onChange={e => {
                                                            const value = e.target.value.replace(/\D/g, '');
                                                            handleApplicationFieldChange(index, 'applicationNo', 0, value);
                                                        }}
                                                    />
                                                    {job.applicationNoIsFilled ? (
                                                        <small className="text-danger">Application No is required</small>
                                                    ) : job.applicationNoInvalid ? (
                                                        <small className="text-danger">Numbers only</small>
                                                    ) : job.applicationNoStartWith01 ? (
                                                        <small className="text-danger">Must start with 01</small>
                                                    ) : job.applicationNoMinLength ? (
                                                        <small className="text-danger">Min 20 characters</small>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>{t("eidBasmati.applicantName")}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control mb-2"
                                                        placeholder="e.g. John Doe"
                                                        value={Array.isArray(job.applicationName) ? job.applicationName[0] || '' : job.applicationName || ''}
                                                        onChange={e => handleApplicationFieldChange(index, 'applicationName', 0, e.target.value)}
                                                    />
                                                    {job.applicationNameIsFilled && (
                                                        <small className="text-danger">Applicant Name is required</small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>{t("eidBasmati.applicantMobile")}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control mb-2"
                                                        placeholder="e.g. 1234567890"
                                                        value={Array.isArray(job.applicationMobile) ? job.applicationMobile[0] || '' : job.applicationMobile || ''}
                                                        onChange={e => {
                                                            const value = e.target.value.replace(/\D/g, '');
                                                            handleApplicationFieldChange(index, 'applicationMobile', 0, value);
                                                        }}
                                                    />
                                                    {job.applicationMobileIsFilled ? (
                                                        <small className="text-danger">Applicant Mobile is required</small>
                                                    ) : job.applicationMobileInvalid ? (
                                                        <small className="text-danger">Invalid mobile number</small>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor={`documentName-${job.id}`}> {t("eidBasmati.documentName")} </label>
                                                    <input
                                                        id={`documentName-${job.id}`}
                                                        name="documentName"
                                                        type="text"
                                                        className="form-control"
                                                        value={job.documentName}
                                                        onChange={onChange(index)}
                                                        disabled={job.isOldDocument}
                                                    />
                                                    {job.documentNameIsFilled && (
                                                        <span style={{ color: 'red' }}>Document name is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor={`passportNo-${job.id}`}>{t("eidBasmati.passportNo")}</label>
                                                    <input
                                                        id={`passportNo-${job.id}`}
                                                        name="passportNo"
                                                        type="text"
                                                        className="form-control"
                                                        value={job.passportNo || ''}
                                                        onChange={onChange(index)}
                                                        placeholder={t("eidBasmati.enterPassportNo")}
                                                        disabled={job.isOldDocument}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor={`document-${job.id}`}> {t("eidBasmati.uploadDocument")} </label>
                                                    <div className="file-card">
                                                        <div className="card-body">
                                                            <div className="kb-data-box">
                                                                <div className="kb-file-upload">
                                                                    <div className="file-upload-box">
                                                                        <input
                                                                            name="document"
                                                                            type="file"
                                                                            id={`document-${job.id}`}
                                                                            className="file-upload-input"
                                                                            onChange={(e) => handleFileChange(index, e)}
                                                                            multiple
                                                                        />
                                                                        <span>
                                                                            Drag and drop or{' '}
                                                                            <span className="file-link">Choose your files</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                {job.document && job.document.length > 0 && (
                                                                    <div className="px-2 kb-attach-box">
                                                                        <h6>New Documents</h6>
                                                                        {job.document
                                                                            .slice(
                                                                                0,
                                                                                expandedRows[`${index}-new`] ? job.document.length : docsLimit
                                                                            )
                                                                            .map((File, fileIndex) => {
                                                                                const { name } = File;
                                                                                return (
                                                                                    <div
                                                                                        className="d-flex align-items-center justify-content-between file-atc-box"
                                                                                        key={fileIndex + name}
                                                                                        style={{
                                                                                            borderBottom: '1px solid #ddd',
                                                                                            padding: '5px 0',
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            type="button"
                                                                                            className="file-action-btn btn btn-sm btn-outline-danger"
                                                                                            onClick={() => handleFileDelete(fileIndex, index)}
                                                                                        >
                                                                                            Delete
                                                                                        </button>
                                                                                        <div className="file-detail d-flex align-items-center">
                                                                                            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>
                                                                                                {name}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        {job.document.length > docsLimit && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link"
                                                                                onClick={() => toggleExpand(index, 'new')}
                                                                            >
                                                                                {expandedRows[`${index}-new`]
                                                                                    ? 'Show Less'
                                                                                    : `+${job.document.length - docsLimit} More`}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {job?.oldDocument && job?.oldDocument.length > 0 && (
                                                                    <div className="px-2 kb-attach-box">
                                                                        <h6>Existing Documents</h6>
                                                                        {job.oldDocument
                                                                            .filter(list => list && typeof list === 'object' && list.name)
                                                                            .slice(
                                                                                0,
                                                                                expandedRows[`${index}-old`] ? job.oldDocument.length : docsLimit
                                                                            )
                                                                            .map((list, fileIndex) => {
                                                                                const { name } = list;
                                                                                return (
                                                                                    <div
                                                                                        className="d-flex align-items-center justify-content-between file-atc-box"
                                                                                        key={fileIndex + list.id}
                                                                                        style={{
                                                                                            borderBottom: '1px solid #ddd',
                                                                                            padding: '5px 0',
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            type="button"
                                                                                            className="file-action-btn btn btn-sm btn-outline-danger"
                                                                                            onClick={() => handleExistingFileDelete(list.id, index)}
                                                                                        >
                                                                                            Delete
                                                                                        </button>
                                                                                        <div className="file-detail d-flex align-items-center">
                                                                                            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>
                                                                                                {name}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        {job.oldDocument.filter(list => list && typeof list === 'object' && list.name).length > docsLimit && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link"
                                                                                onClick={() => toggleExpand(index, 'old')}
                                                                            >
                                                                                {expandedRows[`${index}-old`]
                                                                                    ? 'Show Less'
                                                                                    : `+${job.oldDocument.filter(list => list && typeof list === 'object' && list.name).length - docsLimit} More`}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {job.documentIsFilled && (
                                                        <span style={{ color: 'red' }}>Document is required</span>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="col-md-1 d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => onRemoveHandler(index)}
                                            disabled={requestJob.data.length === 1}
                                        >
                                            <MdRemoveCircle size={22} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </Card>

                        <div className="d-flex justify-content-end">
                            <div className="d-flex justify-content-end m-3">
                                <span className="d-inline-block">
                                    <button className="btn btn-primary" onClick={handleSubmit} >
                                        {t("eidBasmati.proceed")}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>

                    <Modal show={showModal}>
                        <ModalHeader>
                            <Modal.Title>
                                QUATATIONAL DETAILS
                            </Modal.Title>
                            <button className="btn btn-primary" onClick={handleCloseModal}><FaWindowClose /></button>
                        </ModalHeader>
                        <ModalBody>
                            {quotation.headers.length ? (
                                <div className="m-3" >
                                    <BasicTable headers={quotation.headers} data={quotation.rows} />
                                </div>
                            ) : null}
                            <div>
                            </div>
                            <div className="w-100">
                                <DropDown
                                    label={t("eidBasmati.selectPaymentType")}
                                    isSearchable={true}
                                    placeholder={"Online"}
                                    options={paymentTypeOptions}
                                    value={paymentType}
                                    onChange={(value) => {
                                        setPaymentType(value);
                                    }}
                                />
                            </div>
                            <p style={{ color: 'red' }}><b>{validationError}</b></p>
                        </ModalBody>
                        <ModalFooter>
                            <div className="d-flex gap-3 justify-content-end">
                                <LoadingButton
                                    isLoading={saveAsDraftLoading}
                                    onChange={handleSaveAsDraft}
                                >
                                    {t('eidBasmati.saveAsDraft')}
                                </LoadingButton>
                                <LoadingButton
                                    isLoading={requestJobLoading}
                                    onChange={handleRequestJob}
                                >
                                    {t('eidBasmati.requestJob')}
                                </LoadingButton>
                            </div>
                        </ModalFooter>
                    </Modal>
                </div>)}
        </Fragment>
    );
}

export default Edit;
